import React, { useEffect, useState } from 'react'
import './registeruser.css'
import { FaUser } from 'react-icons/fa'
import axios from 'axios'
import { toast, ToastContainer } from 'wc-toast'
import { useAuthContext } from '../../Hooks/useAuthContext'
import { useNavigate } from 'react-router-dom'
import Navigation from '../../Component/Navigation/Navigation'

function RegisterUser() {
  const [resend, setResend]                   = useState('Resend Verification Email')
  const [onlineRegistration, setOnlineRegistration] = useState(true)
  const [strengthMessage, setStrengthMessage] = useState('')
  const [passwordMatch, setPasswordMatch]     = useState('')
  const [btnState, setBtnState]               = useState('Submit')
  const [emailSent, setEmailSent]             = useState(false)
  const [terms, setTerms]                     = useState(false)
  const navigate                              = useNavigate()
  const [register, setRegister]               = useState(false)
  const [completed, setCompleted]             = useState()
  const [currencies, setCurrencies]           = useState(null)
  const { user, dispatch }                    = useAuthContext()

  const [formData, setFormData] = useState({
    firstname: '', lastname: '', country: '', state: '', city: '',
    zipcode: '', dob: '', address: '', phoneNumber: '', email: '',
    occupation: '', pin: '', password: '', incomeRange: '', confirmPassword: '',
  })

  /* ── auth check ────────────────────────────────────────────── */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/check-emailverified`, {
      headers: { Authorization: `Bearer ${user?.token}` },
    }).then(res => {
      if (!res.data.verifyEmail) {
        setOnlineRegistration(false)
        setRegister(false)
        setCompleted(true)
      } else {
        navigate('/dashboard')
      }
    }).catch(err => console.log(err.response.data))
  }, [])

  /* ── resend verification ────────────────────────────────────── */
  const handleResendVerfificationEmail = () => {
    setResend('Resending. Please wait')
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/resend-eamil-verification`, {
      headers: { Authorization: `Bearer ${user?.token}` },
    }).then(() => {
      setResend('Resend Verification Email')
      setEmailSent(true)
      toast.success('Verification Email Sent')
    }).catch(err => {
      toast.error(err.response.data)
      setResend('Resend Verification Email')
    })
    setTimeout(() => setEmailSent(false), 3000)
  }

  /* ── form change ────────────────────────────────────────────── */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    console.log(formData)
  }

  /* ── password strength ──────────────────────────────────────── */
  useEffect(() => {
    if (formData.password !== '') checkPasswordStrength(formData.password)
    else setStrengthMessage('not yet')
  }, [formData.password])

  useEffect(() => {
    if (formData.confirmPassword !== '') {
      setPasswordMatch(formData.confirmPassword === formData.password ? 'Match' : 'Faulty')
    } else {
      setPasswordMatch('not yet')
    }
  }, [formData.confirmPassword, formData.password])

  const checkPasswordStrength = (password) => {
    const upper   = /[A-Z]/.test(formData.password)
    const lower   = /[a-z]/.test(formData.password)
    const nums    = /\d/.test(formData.password)
    const special = /[!@#$%^&*(),.?":{}|<>]/.test(formData.password)
    const long    = password.length >= 8
    if (upper && lower && nums && special && long) setStrengthMessage('Strong')
    else if (upper && lower && nums)               setStrengthMessage('Moderate')
    else                                           setStrengthMessage('Weak')
  }

  /* ── submit ─────────────────────────────────────────────────── */
  const handleSubmit = (e) => {
    e.preventDefault()
    setBtnState('Processing...')
    console.log(formData)
    if (passwordMatch === 'Match') {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/create-user`, formData)
        .then(res => {
          toast.success('Account Created Successfully')
          localStorage.setItem('user', JSON.stringify(res.data))
          dispatch({ type: 'LOGIN', payload: res.data })
          setRegister(false)
          setCompleted(true)
          setBtnState('Submit')
        }).catch(err => {
          setBtnState('Submit')
          toast.error(err.response.data.error)
        })
    }
  }

  /* ── currencies ─────────────────────────────────────────────── */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/currencies`)
      .then(res => setCurrencies(res.data))
      .catch(err => console.log(err))
  }, [])

  /* ── static data ─────────────────────────────────────────────── */
  const employmentTypes = [
    'Self Employed', 'Public/Government Office', 'Private/Partnership Office',
    'Business/Sales', 'Internship', 'Trading/Market', 'Self-employed',
    'Military/Paramilitary', 'Politician/Celebrity',
  ]
  const incomeRanges = [
    '$100.00 - $500.00', '$700.00 - $1,000.00', '$1,000.00 - $2,000.00',
    '$2,000.00 - $5,000.00', '$5,000.00 - $10,000.00', '$15,000.00 - $20,000.00',
    '$25,000.00 - $30,000.00', '$30,000.00 - $70,000.00', '$80,000.00 - $140,000.00',
    '$150,000.00 - $300,000.00', '$300,000.00 - $1,000,000.00',
  ]
  const accountTypes = [
    'Checking Account', 'Saving Account', 'Fixed Deposit Account', 'Current Account',
    'Crypto Currency Account', 'Business Account', 'Non Resident Account',
    'Cooperate Business Account', 'Investment Account',
  ]
  const countries = [
    'Afghanistan','Albania','Algeria','Andorra','Angola','Antigua and Barbuda','Argentina',
    'Armenia','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh',
    'Barbados','Belarus','Belgium','Belize','Benin','Bhutan','Bolivia',
    'Bosnia and Herzegovina','Botswana','Brazil','Brunei','Bulgaria','Burkina Faso',
    'Burundi','Cabo Verde','Cambodia','Cameroon','Canada','Central African Republic',
    'Chad','Chile','China','Colombia','Comoros','Congo (Congo-Brazzaville)',
    'Congo (Democratic Republic of the)','Costa Rica','Croatia','Cuba','Cyprus',
    'Czech Republic','Denmark','Djibouti','Dominica','Dominican Republic','Ecuador',
    'Egypt','El Salvador','Equatorial Guinea','Eritrea','Estonia','Eswatini','Ethiopia',
    'Fiji','Finland','France','Gabon','Gambia','Georgia','Germany','Ghana','Greece',
    'Grenada','Guatemala','Guinea','Guinea-Bissau','Guyana','Haiti','Honduras','Hungary',
    'Iceland','India','Indonesia','Iran','Iraq','Ireland','Israel','Italy','Jamaica',
    'Japan','Jordan','Kazakhstan','Kenya','Kiribati','Kuwait','Kyrgyzstan','Laos',
    'Latvia','Lebanon','Lesotho','Liberia','Libya','Liechtenstein','Lithuania',
    'Luxembourg','Madagascar','Malawi','Malaysia','Maldives','Mali','Malta','Marshall Islands',
    'Mauritania','Mauritius','Mexico','Micronesia','Moldova','Monaco','Mongolia',
    'Montenegro','Morocco','Mozambique','Myanmar (Burma)','Namibia','Nauru','Nepal',
    'Netherlands','New Zealand','Nicaragua','Niger','Nigeria','North Korea','North Macedonia',
    'Norway','Oman','Pakistan','Palau','Panama','Papua New Guinea','Paraguay','Peru',
    'Philippines','Poland','Portugal','Qatar','Romania','Russia','Rwanda',
    'Saint Kitts and Nevis','Saint Lucia','Saint Vincent and the Grenadines','Samoa',
    'San Marino','Sao Tome and Principe','Saudi Arabia','Senegal','Serbia','Seychelles',
    'Sierra Leone','Singapore','Slovakia','Slovenia','Solomon Islands','Somalia',
    'South Africa','South Korea','South Sudan','Spain','Sri Lanka','Sudan','Suriname',
    'Sweden','Switzerland','Syria','Taiwan','Tajikistan','Tanzania','Thailand',
    'Timor-Leste','Togo','Tonga','Trinidad and Tobago','Tunisia','Turkey','Turkmenistan',
    'Tuvalu','Uganda','Ukraine','United Arab Emirates','United Kingdom','United States',
    'Uruguay','Uzbekistan','Vanuatu','Vatican City','Venezuela','Vietnam',
    'Yemen','Zambia','Zimbabwe',
  ]

  /* ── stepper data ────────────────────────────────────────────── */
  const steps = [
    { label: 'Online Registration', active: onlineRegistration },
    { label: 'Terms & Conditions',  active: terms },
    { label: 'Register',            active: register },
    { label: 'Completed',           active: completed },
  ]

  /* ── reset helper ────────────────────────────────────────────── */
  const resetForm = () => setFormData({
    firstname:'', lastname:'', country:'', state:'', city:'', zipcode:'',
    dob:'', address:'', phoneNumber:'', email:'', occupation:'',
    incomeRange:'', accountType:'', currency:'', pin:'', password:'', confirmPassword:'',
  })

  return (
    <div className="ru-page">
      <Navigation />

      {/* ── Hero ─────────────────────────────────────────────── */}
      <div className="ru-hero">
        <div className="ru-hero__content">
          <span className="ru-hero__label">JFE Bank — Open an Account</span>
          <h1 className="ru-hero__title">
            Banking built for <em>your</em> future
          </h1>
          <p className="ru-hero__sub">
            Designed with your needs in mind.
          </p>
        </div>
      </div>

      {/* ── Progress stepper ─────────────────────────────────── */}
      <nav className="ru-stepper" aria-label="Registration progress">
        {steps.map((s, i) => (
          <div
            key={i}
            className={`ru-step${s.active ? ' ru-step--active' : ''}`}
          >
            <span className="ru-step__dot">{i + 1}</span>
            {s.label}
          </div>
        ))}
      </nav>

      {/* ── Page body ────────────────────────────────────────── */}
      <div className="ru-body">

        {/* ══ Step 1 — Get Started ═══════════════════════════ */}
        {onlineRegistration && (
          <div className="ru-card">
            <div className="ru-start">

              <div className="ru-start__left">
                <span className="ru-start__tag">New Account</span>
                <h2 className="ru-start__heading">
                  Let's Get <em>Started</em>
                </h2>
                <p className="ru-start__desc">
                  Get more with Capital Fin Edge. Sign up now and unlock a
                  world of financial possibilities tailored to your life.
                </p>
                <ul className="ru-start__list">
                  <li>Zero-fee account opening</li>
                  <li>Multi-currency support</li>
                  <li>Secure 2FA authentication</li>
                  <li>24/7 online banking access</li>
                </ul>
              </div>

              <div className="ru-start__right">
                <h4>Ready to join?</h4>
                <p>
                  Opening an account takes just a few minutes. You'll need
                  a valid email address and your contact details.
                </p>
                <button
                  className="ru-btn ru-btn--navy"
                  onClick={() => { setOnlineRegistration(false); setTerms(true) }}
                >
                  Get Started Now →
                </button>
              </div>

            </div>
          </div>
        )}

        {/* ══ Step 2 — Terms & Conditions ════════════════════ */}
        {terms && (
          <div className="ru-card">
            <div className="ru-terms">

              <div className="ru-terms__side">
                <div className="ru-terms__side-icon">📋</div>
                <h3>Terms &amp; Conditions</h3>
                <p>
                  Please read the following terms carefully before
                  proceeding with your registration.
                </p>
                <div className="ru-terms__notice">
                  Before you continue, kindly read and accept our terms
                  and conditions.
                </div>
              </div>

              <div className="ru-terms__main">
                <div className="ru-terms__scroll">
                  <p>
                    Before you can start using our online service you must agree to be bound
                    by the conditions below. You must read the conditions before you decide
                    whether to accept them. If you agree to be bound by these conditions,
                    please click the I accept button below. If you click on the Decline button,
                    you will not be able to continue your registration for our online services.
                    We strongly recommend that you print a copy of these conditions for your
                    reference.
                  </p>

                  <h2>1. Definitions</h2>
                  <p>In these conditions the following words have the following meanings:</p>
                  <ul>
                    <li><strong>ACCOUNT</strong>: Any account which you hold and access via our online service.</li>
                    <li><strong>ADDITIONAL SECURITY DETAILS</strong>: The additional information you give us to help us identify you, including the additional security question you provide yourself.</li>
                    <li><strong>IDENTITY DETAILS</strong>: The access code we may provide you with.</li>
                    <li><strong>{process.env.REACT_APP_APP_NAME} ACCOUNT NUMBER, PASSWORD, and ACCOUNT PIN</strong>: You choose to identify yourself when you use our online service.</li>
                    <li><strong>YOU, YOUR, and YOURSELF</strong>: Refer to the person who has entered into this agreement with us.</li>
                  </ul>

                  <h2>2. Using the Online Service</h2>
                  <p>a. These conditions apply to your use of our online service and in relation to any accounts. They explain the relationship between you and us in relation to our online service.</p>
                  <p>b. If any of your accounts is a joint account, these conditions apply to all of you together and any of you separately.</p>
                  <p>c. By registering to use our online service, you accept these conditions and agree that we may communicate with you by email or through our website.</p>
                  <p>d. When you use our online service, you must follow the instructions we give you from time to time.</p>
                  <p>e. Our online sites are secure. You must always use the log-off facility when you are finished and never leave your machine unattended while you are logged in.</p>

                  <h2>3. Security Rules</h2>
                  <p>a. As part of the registration for our online service, you must provide us with identity details before we will allow you to use the services for the first time.</p>
                  <p>b. Every time you use our online service, you must give us your username, your password, and the answer to an additional security question.</p>
                  <p>c. You can change your username or password online by following the instructions on the screen.</p>
                  <p>d. For administration or security reasons, we can require you to choose a new username or change your password before you use (or carry on using) our online service.</p>
                  <p>e. You must not write down, store (whether encrypted or otherwise) on your computer or let anyone else know your password, identity details, or additional security details.</p>
                  <p>f. If you think that someone else knows your password or any of your additional security details:</p>
                  <ul>
                    <li>For your password, change it online as soon as possible. If you have difficulty, phone us on +1 234 567 8910 immediately.</li>
                    <li>For your additional security details, you will need to phone us immediately.</li>
                  </ul>
                  <p>g. We may give the police or any prosecuting authority any information they need if we think it will help them find out if someone else is using your credentials.</p>
                  <p>h. We may also keep any emails sent to or from us to check what was written and to help train our staff.</p>
                </div>

                <div className="ru-terms__actions">
                  <button
                    className="ru-btn ru-btn--danger"
                    onClick={() => { setOnlineRegistration(true); setTerms(false) }}
                  >
                    Decline
                  </button>
                  <button
                    className="ru-btn ru-btn--navy"
                    onClick={() => { setOnlineRegistration(false); setTerms(false); setRegister(true) }}
                  >
                    Accept &amp; Continue →
                  </button>
                </div>
              </div>

            </div>
          </div>
        )}

        {/* ══ Step 3 — Registration Form ═════════════════════ */}
        {register && (
          <div className="ru-card">

            {/* Header */}
            <div className="ru-form-bar">
              <div className="ru-form-bar__icon">
                <FaUser />
              </div>
              <div className="ru-form-bar__text">
                <h2>Create Your Account</h2>
                <p>
                  Kindly provide the information requested below to enable us create an account for you.
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="ru-form-body">

                {/* Personal Details */}
                <div>
                  <div className="ru-section">
                    <span className="ru-section__badge">01</span>
                    <h4>Personal Details</h4>
                  </div>

                  <div className="ru-g2" style={{ marginBottom: '1.4rem' }}>
                    <div className="ru-field">
                      <label>First Name</label>
                      <input type="text" name="firstname" placeholder="First Name"
                        value={formData.firstname} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Last Name</label>
                      <input type="text" name="lastname" placeholder="Last Name"
                        value={formData.lastname} onChange={handleChange} required />
                    </div>
                  </div>

                  <div className="ru-g3" style={{ marginBottom: '1.4rem' }}>
                    <div className="ru-field">
                      <label>Country</label>
                      <select name="country" value={formData.country} onChange={handleChange} required>
                        <option value="">Select Country</option>
                        {countries.map((c, i) => <option key={i} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div className="ru-field">
                      <label>State or Region</label>
                      <input type="text" name="state" placeholder="State or region"
                        value={formData.state} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>City</label>
                      <input type="text" name="city" placeholder="City"
                        value={formData.city} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Zip Code</label>
                      <input type="text" name="zipcode" placeholder="Zipcode / Postal Code"
                        value={formData.zipcode} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Date of Birth</label>
                      <input type="date" name="dob"
                        value={formData.dob} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>House Address</label>
                      <input type="text" name="address" placeholder="House Address"
                        value={formData.address} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Phone Number</label>
                      <input type="text" name="phoneNumber" placeholder="Phone Number"
                        value={formData.phoneNumber} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Email Address</label>
                      <input type="email" name="email" placeholder="Email Address"
                        value={formData.email} onChange={handleChange} required />
                    </div>
                  </div>
                </div>

                {/* Employment Information */}
                <div>
                  <div className="ru-section">
                    <span className="ru-section__badge">02</span>
                    <h4>Employment Information</h4>
                  </div>

                  <div className="ru-g2">
                    <div className="ru-field">
                      <label>Occupation</label>
                      <select name="occupation" value={formData.occupation} onChange={handleChange} required>
                        <option value="">Select Employment Type</option>
                        {employmentTypes.map((t, i) => <option key={i} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="ru-field">
                      <label>Annual Income Range</label>
                      <select name="incomeRange" value={formData.incomeRange} onChange={handleChange} required>
                        <option value="">Select Income Range</option>
                        {incomeRanges.map((r, i) => <option key={i} value={r}>{r}</option>)}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Banking Details */}
                <div>
                  <div className="ru-section">
                    <span className="ru-section__badge">03</span>
                    <h4>Banking Details</h4>
                  </div>

                  <div className="ru-g2">
                    <div className="ru-field">
                      <label>Account Type</label>
                      <select name="accountType" value={formData.accountType} onChange={handleChange} required>
                        <option value="">Select Account Type</option>
                        {accountTypes.map((t, i) => <option key={i} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="ru-field">
                      <label>2FA PIN</label>
                      <input type="number" name="pin" placeholder="PIN"
                        value={formData.pin} onChange={handleChange} required />
                    </div>
                    <div className="ru-field">
                      <label>Password</label>
                      <input type="password" name="password" placeholder="Password"
                        value={formData.password} onChange={handleChange} required />
                      {strengthMessage === 'Weak'     && <span className="ru-hint ru-hint--weak">Weak password</span>}
                      {strengthMessage === 'Moderate' && <span className="ru-hint ru-hint--moderate">Moderate password</span>}
                      {strengthMessage === 'Strong'   && <span className="ru-hint ru-hint--strong">Strong password</span>}
                    </div>
                    <div className="ru-field">
                      <label>Confirm Password</label>
                      <input type="password" name="confirmPassword" placeholder="Confirm Password"
                        value={formData.confirmPassword} onChange={handleChange} required />
                      {passwordMatch === 'Faulty' && <span className="ru-hint ru-hint--error">Passwords do not match</span>}
                    </div>
                  </div>
                </div>

              </div>

              {/* Actions */}
              <div className="ru-form-actions">
                <button
                  type="reset"
                  className="ru-btn ru-btn--light"
                  onClick={resetForm}
                >
                  Reset Form
                </button>
                <button
                  type="submit"
                  className="ru-btn ru-btn--navy"
                  disabled={btnState === 'Processing...'}
                >
                  {btnState === 'Processing...' ? 'Processing…' : 'Submit Application →'}
                </button>
              </div>
            </form>

          </div>
        )}

        {/* ══ Step 4 — Email Verification ════════════════════ */}
        {completed && (
          <div className="ru-card">
            <div className="ru-verify">

              <div className="ru-verify__left">
                <div className="ru-verify__icon">✉️</div>
                <h2>Email Verification Required</h2>
                <p>Please verify your email to Continue.</p>
              </div>

              <div className="ru-verify__right">
                <h3>Almost there</h3>
                <p>Check your inbox for the verification link we sent you.</p>
                <ul className="ru-verify__steps">
                  <li><span>1</span> Open your email inbox</li>
                  <li><span>2</span> Find the email from JFE Bank</li>
                  <li><span>3</span> Click the verification link to activate your account</li>
                </ul>
                <button
                  className="ru-btn ru-btn--navy ru-btn--full"
                  onClick={handleResendVerfificationEmail}
                  disabled={resend === 'Resending. Please wait'}
                >
                  {resend}
                </button>
                {emailSent && (
                  <div className="ru-verify__sent">
                    ✓ Verification email sent!
                  </div>
                )}
              </div>

            </div>
          </div>
        )}

      </div>
    </div>
  )
}

export default RegisterUser